// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__5+C0y","modal__title":"styles_modal__title__xEvps","modal__footer":"styles_modal__footer__8Sqk6"};